import AdjustOrder from './src/main'

AdjustOrder.install = function (Vue) {
    Vue.component(AdjustOrder.name, AdjustOrder)
}

export default AdjustOrder